module.exports = __webpack_public_path__ + "img/okladka1.735192b3.jpg";